<ng-container *appTranslate="let t">
  <div class="flex max-mobile:flex-col-reverse h-dvh">
    <nav class="z-1101">
      <ui-sidenav>
        <a
          class="row max-mobile:hidden"
          href="javascript:void(0)"
          routerLink="/"
          tooltipPosition="right"
          tooltipStyleClass="max-w-overlay whitespace-pre-line"
          [pTooltip]="`${getOrganizationNameForHeader()}${!settings.isCreatorMasterOrganization && !settings.isLicensed && settings.creatorOrganizationName ? '\n' + getParentOrganizationNameForHeader() : ''}`"
        >
          <p-avatar
            styleClass="border-1 border-surface-border bg-surface-bg-white p-1 *:rounded-none *:h-auto"
            [image]="image()"
            size="large"
            shape="circle"
          />
          @if (viewMode !== ViewModeOption.Compact) {
            <div
              class="max-laptop:hidden col gap-0 text-text-body"
              data-testid="profile-info"
              [attr.data-organization-code]="getOrganizationCode()"
            >
              <span class="font-semibold">{{ getOrganizationNameForHeader() }}</span>
              @if (!settings.isCreatorMasterOrganization && !settings.isLicensed && settings.creatorOrganizationName) {
                <span class="text-xs">
                  {{ getParentOrganizationNameForHeader() }}
                </span>
              }
            </div>
          }
        </a>

        <ng-template #primary>
          @if (isCandidate) {
            @if (menu?.tasks?.enabled) {
              <ui-sidenav-panel>
                <ui-sidenav-header>
                  <ui-sidenav-item
                    class="max-mobile:hidden"
                    [iconOnly]="viewMode === ViewModeOption.Compact"
                    [label]="t('myTasks.title')"
                    icon="icon-[mi--check-list-checkmark]"
                    [badge]="inboxCount$ | async"
                    routerLink="/app/processes/tasks"
                    data-testid="menu-item-my-tasks"
                  />

                  <ui-sidenav-item
                    class="min-mobile:hidden"
                    [iconOnly]="viewMode === ViewModeOption.Compact"
                    [label]="t('myTasks.titleShort')"
                    icon="icon-[mi--check-list-checkmark]"
                    [badge]="inboxCount$ | async"
                    routerLink="/app/processes/tasks"
                    data-testid="menu-item-my-tasks"
                  />
                </ui-sidenav-header>
              </ui-sidenav-panel>
            }

            @if (menu?.profile?.enabled) {
              <ui-sidenav-panel>
                <ui-sidenav-header>
                  <ui-sidenav-item
                    [iconOnly]="viewMode === ViewModeOption.Compact"
                    [label]="t('candidate.profile')"
                    icon="icon-[mi--user-edit-pen]"
                    routerLink="/app/profile"
                    data-testid="menu-item-profile"
                  />
                </ui-sidenav-header>
              </ui-sidenav-panel>
            }

            @if (menu?.employerSearch?.enabled) {
              <ui-sidenav-panel>
                <ui-sidenav-header>
                  <ui-sidenav-item
                    [iconOnly]="viewMode === ViewModeOption.Compact"
                    [label]="t('employerSearch.title')"
                    icon="icon-[mi--link-angle-right]"
                    routerLink="/app/employers"
                    data-testid="menu-item-employer-search"
                  />
                </ui-sidenav-header>
              </ui-sidenav-panel>
            }

            <ui-sidenav-panel>
              <ui-sidenav-header>
                <ui-sidenav-item
                  [iconOnly]="viewMode === ViewModeOption.Compact"
                  [label]="t('attachments.title')"
                  icon="icon-[mi--document-file-blank]"
                  routerLink="/app/documents"
                  data-testid="menu-item-documents"
                />
              </ui-sidenav-header>
            </ui-sidenav-panel>

            @if (isEducationModuleVisibleForCandidate) {
              <ui-sidenav-panel>
                <ui-sidenav-header>
                  <ui-sidenav-item
                    [iconOnly]="viewMode === ViewModeOption.Compact"
                    [label]="t('educationManagement.title2')"
                    icon="icon-[mi--open-book-graduate-hat]"
                    routerLink="/app/education"
                    data-testid="menu-item-education"
                  />
                </ui-sidenav-header>
              </ui-sidenav-panel>
            }
          } @else {
            <ui-sidenav-panel *appPermissions="UserPermission.User">
              <ui-sidenav-header>
                <ui-sidenav-item
                  [iconOnly]="viewMode === ViewModeOption.Compact"
                  [label]="t('candidates.title2')"
                  icon="icon-[mi--users]"
                  data-testid="menu-item-candidates"
                />
              </ui-sidenav-header>

              <ui-sidenav-content>
                <p class="text-accordion-heading mb-1">
                  {{ t("candidates.title2") }}
                </p>

                <ui-sidenav-item
                  [label]="t('candidates.edit')"
                  icon="icon-[mi--users]"
                  routerLink="/app/candidates/edit"
                  data-testid="menu-item-candidate-profile"
                />

                <ui-sidenav-item
                  *appLicensed
                  [label]="t('collections.title')"
                  icon="icon-[mi--folder-list]"
                  routerLink="/app/collections/edit"
                  data-testid="menu-item-candidate-collection"
                />

                <ui-sidenav-item
                  *appLicensed
                  [label]="t('candidates.events')"
                  icon="icon-[mi--calendar-chedule]"
                  routerLink="/app/candidates/events"
                  data-testid="menu-item-candidate-events"
                />

                <ui-sidenav-item
                  [label]="t('candidates.view2')"
                  icon="icon-[mi--check-mark-square-select]"
                  routerLink="/app/candidates/view"
                  data-testid="menu-item-candidate-view"
                />
              </ui-sidenav-content>
            </ui-sidenav-panel>

            @if (
              (enabledFeatures.talentPool && talentPoolVisibility()?.userPortal) ||
              talentPoolVisibility()?.contributorPortal ||
              talentPoolVisibility()?.talentPoolManagement
            ) {
              <ng-container>
                <ui-sidenav-panel *appPermissions="[UserPermission.Administrator, UserPermission.TalentpoolUser]">
                  <ui-sidenav-header>
                    <ui-sidenav-item
                      [iconOnly]="viewMode === ViewModeOption.Compact"
                      [label]="t('talentPool.sidenav.title')"
                      icon="icon-[mi--user-profile-cards]"
                    />
                  </ui-sidenav-header>

                  <ui-sidenav-content>
                    <p class="text-accordion-heading mb-1">
                      {{ t("talentPool.sidenav.header") }}
                    </p>

                    @if (talentPoolVisibility()?.userPortal) {
                      <ui-sidenav-item
                        [label]="t('talentPool.sidenav.talentSearch')"
                        icon="icon-[mi--user-profile-cards]"
                        routerLink="/app/talent-pools/view"
                        data-testid="menu-item-talent-pool-view"
                      />
                    }

                    @if (talentPoolVisibility()?.contributorPortal) {
                      <ui-sidenav-item
                        [label]="t('talentPool.sidenav.contributorPortal')"
                        icon="icon-[mi--checklist-user]"
                        routerLink="/app/talent-pools/requests"
                        data-testid="menu-item-talent-pool-requests"
                      />
                    }

                    @if (talentPoolVisibility()?.talentPoolManagement) {
                      <ui-sidenav-item
                        [label]="t('talentPool.sidenav.talentpoolManagement')"
                        icon="icon-[mi--user-select-cursor-square]"
                        routerLink="/app/talent-pools/edit"
                        data-testid="menu-item-talent-pool-edit"
                      />
                    }
                  </ui-sidenav-content>
                </ui-sidenav-panel>
              </ng-container>
            }

            <ui-sidenav-panel *appPermissions="UserPermission.User">
              <ui-sidenav-header>
                <ui-sidenav-item
                  [iconOnly]="viewMode === ViewModeOption.Compact"
                  [label]="t('processes.titleMany')"
                  icon="icon-[mi--programing-data-1]"
                  [badge]="inboxCount$ | async"
                />
              </ui-sidenav-header>

              <ui-sidenav-content>
                <p class="text-accordion-heading mb-1">
                  {{ t("processes.titleMany") }}
                </p>

                <ui-sidenav-item
                  [label]="t('myTasks.title')"
                  icon="icon-[mi--list-task-checkmark]"
                  [badge]="inboxCount$ | async"
                  routerLink="/app/processes/tasks"
                  data-testid="menu-item-my-tasks"
                />

                <ng-container *appLicensed>
                  <ui-sidenav-item
                    [label]="t('processes.edit2')"
                    icon="icon-[mi--programming-code-list-checkmark]"
                    routerLink="/app/processes/edit"
                    data-testid="menu-item-process-edit"
                  />
                </ng-container>

                <ui-sidenav-item
                  [label]="t('processes.view')"
                  icon="icon-[mi--dashboard-12]"
                  routerLink="/app/processes/view"
                  data-testid="menu-item-running-process"
                />
              </ui-sidenav-content>
            </ui-sidenav-panel>

            <ui-sidenav-panel
              *appPermissions="[
                UserPermission.Administrator,
                UserPermission.CourseAdministrator,
                UserPermission.CourseTeacher,
                UserPermission.CourseObserver,
              ]"
            >
              <ui-sidenav-header>
                <ui-sidenav-item
                  [iconOnly]="viewMode === ViewModeOption.Compact"
                  [label]="t('educationManagement.title2')"
                  icon="icon-[mi--open-book-graduate-hat]"
                  data-testid="menu-item-education"
                />
              </ui-sidenav-header>

              <ui-sidenav-content>
                <p class="text-accordion-heading mb-1">
                  {{ t("educationManagement.title") }}
                </p>

                <ng-container *appLicensed>
                  <ui-sidenav-item
                    *appPermissions="[
                      UserPermission.Administrator,
                      UserPermission.CourseAdministrator,
                      UserPermission.CourseTeacher,
                    ]"
                    [label]="t('educationModules.title')"
                    icon="icon-[mi--folder-bookmark]"
                    routerLink="/app/education/modules"
                    data-testid="menu-item-module"
                  />
                </ng-container>

                <ui-sidenav-item
                  *appPermissions="[
                    UserPermission.Administrator,
                    UserPermission.CourseAdministrator,
                    UserPermission.CourseTeacher,
                    UserPermission.CourseObserver,
                  ]"
                  [label]="t('educationCourses.title')"
                  icon="icon-[mi--blackboard-blackboard-graduate-hat]"
                  routerLink="/app/education/courses"
                  data-testid="menu-item-course"
                />

                <ui-sidenav-item
                  *appPermissions="[
                    UserPermission.Administrator,
                    UserPermission.CourseAdministrator,
                    UserPermission.CourseTeacher,
                  ]"
                  [label]="t('educationExams.title')"
                  icon="icon-[mi--checklist-pen]"
                  routerLink="/app/education/exams"
                  data-testid="menu-item-exam"
                />

                <ui-sidenav-item
                  *appPermissions="[
                    UserPermission.Administrator,
                    UserPermission.CourseAdministrator,
                    UserPermission.CourseTeacher,
                  ]"
                  [label]="t('educationExamResults.title')"
                  icon="icon-[mi--list-task-graduate-hat]"
                  routerLink="/app/education/exam-results/overview"
                  data-testid="menu-item-audit"
                />
              </ui-sidenav-content>
            </ui-sidenav-panel>

            <ng-container>
              <ui-sidenav-panel
                class="max-mobile:hidden"
                *appPermissions="[
                  UserPermission.Administrator,
                  UserPermission.PartnerAdministrator,
                  UserPermission.CrmContributor,
                ]"
              >
                <ui-sidenav-header>
                  <ui-sidenav-item
                    [iconOnly]="viewMode === ViewModeOption.Compact"
                    [label]="t('organizations.menuTitle')"
                    icon="icon-[mi--office-checkamrk]"
                    routerLink="/app/settings/organizations/{{ organizationId }}"
                    data-testid="menu-item-customer"
                  />
                </ui-sidenav-header>
              </ui-sidenav-panel>
            </ng-container>

            <ng-container *appLicensed>
              <ui-sidenav-panel class="max-mobile:hidden" *appPermissions="UserPermission.BillingAdministrator">
                <ui-sidenav-header>
                  <ui-sidenav-item
                    [iconOnly]="viewMode === ViewModeOption.Compact"
                    [label]="t('billing.title')"
                    icon="icon-[mi--money-coins-1]"
                    routerLink="/app/settings/organizations/invoice/{{ organizationId }}"
                    data-testid="menu-item-invoice"
                  />
                </ui-sidenav-header>
              </ui-sidenav-panel>
            </ng-container>
          }
        </ng-template>

        <ng-template #secondary>
          <ui-sidenav-panel class="max-mobile:hidden">
            <ui-sidenav-header>
              <ui-sidenav-item
                [iconOnly]="viewMode === ViewModeOption.Compact"
                [label]="t('ankaadiaEnvironment.classic.switchTo.title')"
                (clicked)="openClassicAnkaadiaUi($event)"
              >
                <ng-template #icon>
                  <img
                    src="/assets/layout/images/ankaadia-logo.svg"
                    class="grayscale-100 w-(--p-sidenav-icon-font-size) h-(--p-sidenav-icon-font-size)"
                  />
                </ng-template>
              </ui-sidenav-item>
            </ui-sidenav-header>
          </ui-sidenav-panel>

          @if (!isCandidate) {
            <ui-sidenav-panel
              *appPermissions="[
                UserPermission.Administrator,
                UserPermission.PartnerAdministrator,
                UserPermission.ContentAdministrator,
                UserPermission.User,
                UserPermission.CandidateManager,
              ]"
            >
              <ui-sidenav-header>
                <ui-sidenav-item
                  [iconOnly]="viewMode === ViewModeOption.Compact"
                  [label]="t('notifications.title')"
                  icon="icon-[mi--bell-notification]"
                  [badge]="notificationCount$ | async"
                />
              </ui-sidenav-header>

              <ui-sidenav-content>
                <p class="text-accordion-heading mb-1">
                  {{ t("notifications.title") }}
                </p>

                <ui-sidenav-item
                  [label]="t('notifications.title')"
                  [badge]="notificationCount$ | async"
                  icon="icon-[mi--bell-notification]"
                  routerLink="/app/notifications"
                />

                <ui-sidenav-item
                  *appPermissions="UserPermission.User"
                  [label]="t('activityLog.title')"
                  icon="pi pi-info-circle"
                  routerLink="/app/activity"
                />
              </ui-sidenav-content>
            </ui-sidenav-panel>

            <ui-sidenav-panel
              class="max-mobile:hidden"
              *appPermissions="[
                UserPermission.Administrator,
                UserPermission.ProcessAdministrator,
                UserPermission.ContentAdministrator,
              ]"
            >
              <ui-sidenav-header>
                <ui-sidenav-item
                  [iconOnly]="viewMode === ViewModeOption.Compact"
                  [label]="t('settings.title')"
                  icon="icon-[mi--settings-round]"
                  routerLink="/app/settings-menu"
                  data-testid="menu-item-settings-menu"
                />
              </ui-sidenav-header>
            </ui-sidenav-panel>
          }

          @if (settings.isMasterOrganization && settings.isMasterUser) {
            <ui-sidenav-panel class="max-mobile:hidden">
              <ui-sidenav-header>
                <ui-sidenav-item
                  [iconOnly]="viewMode === ViewModeOption.Compact"
                  [label]="t('kpi.dashboard.title')"
                  icon="icon-[mi--blackboard-chart-2]"
                  routerLink="/kpi"
                />
              </ui-sidenav-header>
            </ui-sidenav-panel>
          }

          @if (isChatEnabled$ | async) {
            <ui-sidenav-panel class="max-mobile:hidden">
              <ui-sidenav-header>
                <ui-sidenav-item
                  [iconOnly]="viewMode === ViewModeOption.Compact"
                  [label]="t('chats.title')"
                  [badge]="unreadMessagesCount$ | async"
                  icon="icon-[mi--user-chat-messages-bubble]"
                  (clicked)="openWidget()"
                />
              </ui-sidenav-header>
            </ui-sidenav-panel>
          }

          @if (helpUrl$ | async; as helpUrl) {
            <ui-sidenav-panel class="max-mobile:hidden">
              <ui-sidenav-header>
                <ui-sidenav-item
                  [iconOnly]="viewMode === ViewModeOption.Compact"
                  [label]="t('help.title')"
                  icon="icon-[mi--life-ring-help-support]"
                  (clicked)="goToUrl(helpUrl)"
                />
              </ui-sidenav-header>
            </ui-sidenav-panel>
          }

          <ui-sidenav-panel class="max-mobile:hidden">
            <ui-sidenav-header>
              <new-ui-translation-proposal-button
                class="empty:hidden"
                [sidebarMode]="true"
                [iconOnly]="viewMode === ViewModeOption.Compact"
              />
            </ui-sidenav-header>
          </ui-sidenav-panel>

          <div class="max-mobile:hidden">
            <ng-container *ngTemplateOutlet="user" />
          </div>

          <ui-sidenav-panel class="min-mobile:hidden">
            <ui-sidenav-header>
              <ui-sidenav-item
                [iconOnly]="viewMode === ViewModeOption.Compact"
                [label]="t('common.more2')"
                icon="pi pi-ellipsis-h"
              />
            </ui-sidenav-header>

            <ui-sidenav-content>
              <p class="text-accordion-heading mb-1">
                {{ t("common.more2") }}
              </p>

              <ui-sidenav-item
                *appPermissions="[
                  UserPermission.Administrator,
                  UserPermission.PartnerAdministrator,
                  UserPermission.CrmContributor,
                ]"
                [label]="t('organizations.menuTitle')"
                icon="pi pi-th-large"
                routerLink="/app/settings/organizations/{{ organizationId }}"
                data-testid="menu-item-customer"
              />

              <ng-container *appLicensed>
                <ui-sidenav-item
                  *appPermissions="UserPermission.BillingAdministrator"
                  [label]="t('billing.title')"
                  icon="pi pi-euro"
                  routerLink="/app/settings/organizations/invoice/{{ organizationId }}"
                  data-testid="menu-item-invoice"
                />
              </ng-container>

              <ui-sidenav-item
                *appPermissions="[
                  UserPermission.Administrator,
                  UserPermission.ProcessAdministrator,
                  UserPermission.ContentAdministrator,
                ]"
                [label]="t('settings.title')"
                icon="pi pi-cog"
                routerLink="/app/settings-menu"
                data-testid="menu-item-settings-menu"
              />

              <ui-sidenav-item
                [label]="t('ankaadiaEnvironment.classic.switchTo.title')"
                (clicked)="openClassicAnkaadiaUi($event)"
              >
                <ng-template #icon>
                  <img
                    [pTooltip]="t('ankaadiaEnvironment.classic.switchTo.title')"
                    src="/assets/layout/images/ankaadia-logo.svg"
                    class="grayscale-100 w-(--p-sidenav-icon-font-size) h-(--p-sidenav-icon-font-size)"
                  />
                </ng-template>
              </ui-sidenav-item>

              @if (isChatEnabled$ | async) {
                <ui-sidenav-item
                  [label]="t('chats.title')"
                  [badge]="unreadMessagesCount$ | async"
                  icon="pi pi-comment"
                  routerLink="/app/chats/widget"
                  data-testid="menu-item-chats-menu"
                />
              }

              <ng-container *ngTemplateOutlet="user" />
            </ui-sidenav-content>
          </ui-sidenav-panel>
        </ng-template>
      </ui-sidenav>
    </nav>

    <main class="flex-1 w-full overflow-y-auto min-w-0 z-0">
      <router-outlet />
    </main>
  </div>

  <new-ui-user-feedback />
  <new-ui-chat-widget-dialog [appendTo]="chatWidgetDialogProxy"></new-ui-chat-widget-dialog>
  <div #chatWidgetDialogProxy></div>

  @if (showResetSuccessDialog) {
    <p-dialog [(visible)]="showResetSuccessDialog" [modal]="true" styleClass="w-overlay" appendTo="body">
      <ui-emptystate
        class="py-[3%]"
        image="/assets/layout/images/new-ui/mail.png"
        [caption]="t('password.resetSuccessTitle')"
        [description]="t('password.resetSuccessDescription')"
      />
    </p-dialog>
  }

  @if (showMessageReceptionSuccessDialog) {
    <p-dialog [(visible)]="showMessageReceptionSuccessDialog" [modal]="true" styleClass="w-overlay" appendTo="body">
      <ui-emptystate
        class="py-[3%]"
        image="/assets/layout/images/new-ui/mail.png"
        [caption]="t('messagesReception.resetSuccess')"
        [description]="t('messagesReception.resetSuccessDescription')"
      />
    </p-dialog>
  }

  @if (showDeleteDataSuccessDialog) {
    <p-dialog [(visible)]="showDeleteDataSuccessDialog" [modal]="true" styleClass="w-overlay" appendTo="body">
      <ui-emptystate
        class="py-[3%]"
        image="/assets/layout/images/new-ui/mail.png"
        [caption]="t('candidateDeletion.succes')"
        [description]="t('candidateDeletion.succesDescription')"
      />
    </p-dialog>
  }

  @if (showLanguageDialog) {
    <p-dialog
      [(visible)]="showLanguageDialog"
      [header]="t('languages.title')"
      [modal]="true"
      styleClass="w-overlay"
      appendTo="body"
    >
      <div class="dialog-form">
        <new-ui-communication-language [label]="t('userLanguage.titleShort')" />

        <new-ui-application-language />
      </div>
    </p-dialog>
  }

  @if (showOrganizationSwitchDialog) {
    <p-dialog
      [(visible)]="showOrganizationSwitchDialog"
      [header]="t('organization.switch')"
      [modal]="true"
      styleClass="w-overlay border-none overflow-hidden"
      appendTo="body"
    >
      <new-ui-organization-switch
        [organizations]="myOtherOrganizations$ | async"
        (filtered)="loadOrganizations($event)"
        (switched)="switchOrganization($event)"
      />
    </p-dialog>
  }

  <ng-template #user>
    <ui-sidenav-panel>
      <ui-sidenav-header data-testid="sidenav-user-profile-header">
        <ui-sidenav-item class="min-mobile:hidden" [label]="userDisplayName" icon="icon-[mi--user-profile]" />

        <ui-sidenav-item
          class="max-mobile:hidden"
          [iconOnly]="viewMode === ViewModeOption.Compact"
          [label]="userDisplayName"
          icon="icon-[mi--user-profile]"
        />
      </ui-sidenav-header>

      <ui-sidenav-content>
        <div class="h-full flex flex-col justify-between">
          <div class="col gap-(--p-sidenav-panel-gap)">
            <div class="flex gap-2 relative">
              @if (isCandidate) {
                <new-ui-candidate-profile-image />
              } @else {
                <p-avatar class="shrink-0" icon="icon-[mi--user-profile]" shape="circle" size="large" />
              }

              <div class="flex flex-col gap-1 min-w-px">
                <span class="text-body-text-semibold truncate">
                  {{ userDisplayName }}
                </span>

                <a
                  class="flex gap-2 items-baseline text-text-caption font-normal"
                  href="javascript:void(0)"
                  (click)="copyUserEmailToClipboard()"
                >
                  <span class="truncate">{{ userEmail }}</span>
                  <i class="pi pi-copy"></i>
                </a>
              </div>
            </div>

            <p-divider />

            <div class="flex gap-2">
              <new-ui-dark-mode-switch />
              <new-ui-view-mode-switch [(selectedMode)]="viewMode" />
            </div>

            @if (switchableOrganizationCount > 0) {
              <ui-sidenav-item
                data-testid="sidenav-organization-switch"
                [label]="t('organization.switch')"
                icon="icon-[mi--displays-network-servers]"
                (clicked)="showOrganizationSwitchDialog = true"
              />
            }

            <ui-sidenav-item class="laptop:hidden" [label]="t('home.title')" icon="pi pi-home" (clicked)="goHome()" />

            <ui-sidenav-item
              [label]="t('languages.title')"
              icon="icon-[mi--earth-globe-modern]"
              (clicked)="showLanguageDialog = true"
            />

            @if (messagesReception) {
              <label class="p-2 row font-semibold">
                <p-toggleswitch
                  class="flex"
                  [(ngModel)]="messagesReception.enabled"
                  (onChange)="toggleMessagesReception({ value: $event.checked, target: $event.originalEvent?.target })"
                />

                {{ t("messagesReception.title") }}
              </label>
            }

            @if (userGaveConsent$ | async) {
              <ui-sidenav-item
                [label]="t('consent.title')"
                icon="icon-[mi--thumbs-up-documet-contract]"
                routerLink="/app/terms-and-conditions"
              />
            }

            @if (!isCandidate) {
              <ui-sidenav-item
                *appPermissions="OnlineApplicationPermissions"
                [label]="t('onlineApplication.credentials')"
                icon="icon-[mi--file-cv-job-work]"
                routerLink="/app/settings/online-applications/credentials"
              />
            }

            <ui-sidenav-item
              [label]="t('password.reset')"
              icon="icon-[mi--password-edit-protection]"
              (clicked)="resetPassword($event)"
            />

            <ui-sidenav-item [label]="t('feedback.title')" icon="icon-[mi--chat-star]" (clicked)="openFeedback()" />

            @if (helpUrl$ | async; as helpUrl) {
              <ui-sidenav-item
                class="laptop:hidden"
                [label]="t('help.title')"
                icon="pi pi-question-circle"
                (clicked)="goToUrl(helpUrl)"
              />
            }

            @if (isCandidate) {
              <ui-sidenav-item
                [label]="t('candidateDeletion.title')"
                icon="icon-[mi--edit-erase]"
                (clicked)="deleteCandidateData($event)"
              />
            }

            <ui-sidenav-item
              [label]="t('logout.title')"
              icon="icon-[mi--exit-door-log-out-1]"
              (clicked)="logout($event)"
              data-testid="navbar-logout"
            />
          </div>

          <div class="text-subtle-text-regular">
            <i class="pi pi-ankaadia"></i>
            <span>Ankaadia v{{ version() }}</span>
          </div>
        </div>
      </ui-sidenav-content>
    </ui-sidenav-panel>
  </ng-template>

  <p-confirmDialog [key]="classicAnkaadiaConfirmationKey" />
</ng-container>
